<div class="test-page">
  <h1 class="test-page__title">Dropdown test</h1>

  <div class="test-page__field">
    <yds-dropdown
      [items]="firstOptions"
      [(ngModel)]="selectedFirst"
      [placeholder]="'Select an item'"
    />
  </div>

  <div class="test-page__field">
    <yds-dropdown
      [items]="secondOptions"
      [(ngModel)]="selectedSecond"
      [placeholder]="'Select an item'"
    />
  </div>

  <h1 class="test-page__title">Combobox test</h1>

  <div class="test-page__field">
    <yds-combobox
      [items]="firstOptions"
      [(ngModel)]="selectedThird"
      [placeholder]="'Select an item'"
    />
  </div>

  <div class="test-page__field">
    <yds-combobox
      [items]="secondOptions"
      [(ngModel)]="selectedFourth"
      [placeholder]="'Select an item'"
    />
  </div>
</div>
